import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { alpha, useTheme } from '@mui/material/styles';

import { useResponsive } from 'src/hooks/use-responsive';

import { bgGradient } from 'src/theme/css';

import Logo from 'src/components/logo';

// ----------------------------------------------------------------------

// The sign-in pages: a welcome panel on the left (desktop only) and the form
// on the right. A page can bring its own left panel (`aside`) instead of the
// default title and illustration.
export default function AuthClassicLayout ({ children, image, title, aside }) {

  const theme = useTheme();

  const mdUp = useResponsive('up', 'md');

  const renderLogo = (
    <Logo
      sx={{
        zIndex: 9,
        position: 'absolute',
        m: { xs: 2, md: 5 },
      }}
    />
  );

  // On desktop the form sits in the middle of the screen, so a laptop shows
  // all of it without scrolling. On phones it starts just under the logo.
  const renderContent = (
    <Stack
      justifyContent={{ md: 'center' }}
      sx={{
        width: 1,
        mx: 'auto',
        maxWidth: 580,
        px: { xs: 2, md: 8 },
        pt: { xs: 10, md: 5 },
        pb: { xs: 10, md: 5 },
      }}
    >
      {children}
    </Stack>
  );

  const renderSection = (
    <Stack
      flexGrow={1}
      spacing={10}
      alignItems="center"
      justifyContent="center"
      sx={{
        ...bgGradient({
          color: alpha(
            theme.palette.background.default,
            theme.palette.mode === 'light' ? 0.88 : 0.94
          ),
          imgUrl: '/assets/background/overlay_2.jpg',
        }),
      }}
    >
      <Typography variant="h3" sx={{ maxWidth: 480, textAlign: 'center' }}>
        {title || 'Hi, welcome back'}
      </Typography>

      <Box
        component="img"
        alt="auth"
        src={image || '/assets/illustrations/undraw_hello_re_3evm.svg'}
        sx={{
          maxWidth: {
            xs: 480,
            lg: 560,
            xl: 720,
          },
        }}
      />

    </Stack>
  );

  return (
    <Stack
      component="main"
      direction="row"
      sx={{
        minHeight: '100vh',
      }}
    >
      {renderLogo}

      {mdUp && (aside || renderSection)}

      {renderContent}
    </Stack>
  );
}

AuthClassicLayout.propTypes = {
  aside: PropTypes.node,
  children: PropTypes.node,
  image: PropTypes.string,
  title: PropTypes.string,
};
